/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_EssentialInputs */

const en_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential cookies: `)
};

const de_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notwendige Cookies: `)
};

const fr_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies essentiels : `)
};

const es_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies esenciales: `)
};

const it_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie essenziali: `)
};

const nl_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentiële cookies: `)
};

const pl_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezbędne ciasteczka: `)
};

const fi_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välttämättömät evästeet: `)
};

const da_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nødvendige cookies: `)
};

const sv_privacy_cookies_essential = /** @type {(inputs: Privacy_Cookies_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nödvändiga cookies: `)
};

/**
* | output |
* | --- |
* | "Essential cookies:" |
*
* @param {Privacy_Cookies_EssentialInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_essential = /** @type {((inputs?: Privacy_Cookies_EssentialInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_EssentialInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_cookies_essential(inputs)
	if (locale === "fr") return fr_privacy_cookies_essential(inputs)
	if (locale === "es") return es_privacy_cookies_essential(inputs)
	if (locale === "it") return it_privacy_cookies_essential(inputs)
	if (locale === "nl") return nl_privacy_cookies_essential(inputs)
	if (locale === "pl") return pl_privacy_cookies_essential(inputs)
	if (locale === "fi") return fi_privacy_cookies_essential(inputs)
	if (locale === "da") return da_privacy_cookies_essential(inputs)
	if (locale === "sv") return sv_privacy_cookies_essential(inputs)
	return en_privacy_cookies_essential(inputs)
});